export default {
  allOffers: (state) => state.offers,
  featuredOffers: (state) => state.offers.filter((o) => o.featured),
  selectedOffer: (state) => state.selectedOffer,
  appPhase: (state) => state.appPhase,
  otpVerified: (state) => state.otpVerified,
  candidateEmail: (state) => state.candidateEmail,

  isLoadingOffers: (state) => state.loading.offers,
  isSendingOtp: (state) => state.loading.sendOtp,
  isVerifyingOtp: (state) => state.loading.verifyOtp,
  isSubmitting: (state) => state.loading.submit,

  offersError: (state) => state.errors.offers,
  emailError: (state) => state.errors.email,
  otpError: (state) => state.errors.otp,
  submitError: (state) => state.errors.submit,
};
